import React from 'react'
import { FormControl, InputLabel, Select, SelectProps } from '@mui/material'
import { FieldValues } from 'react-hook-form'

import { createFormControl } from './form-control.tsx'
import { OmittedFormControlProps } from './controls.types.ts'

export const SelectFieldControl = <FormValues extends FieldValues>({
  label,
  ...props
}: SelectProps & OmittedFormControlProps<FormValues>): React.ReactElement => {
  const FormSelect = createFormControl<SelectProps>(Select)

  return (
    <FormControl fullWidth>
      <InputLabel id="status-label">{label}</InputLabel>
      <FormSelect {...props} />
    </FormControl>
  )
}
